import {
  AddListing,
  CreateProfile,
  ExploreMatching,
  Facebook,
  Four,
  GetView,
  Instagram,
  Linkedin,
  One,
  SearchPro,
  ShareGrow,
  Three,
  Two,
  ViewProfile,
  XSocial,
  Youtube,
  ZeroOne,
} from "../styled/AllImages";
import { Box, Span, SpanStyled } from "../styled/Elements";

export const NavDataConfig = [
  {
    to: "signup",
    label: "sign_up",
  },
  {
    to: "login",
    label: "login",
  },
  {
    to: "login",
    label: "About",
  },
  {
    to: "privacy-policy",
    label: "PrivacyPolicy",
  },
  {
    to: "terms-conditions",
    label: "TermsConditions",
  },
];
export const NavData = [
  {
    to: "home",
    label: "Home",
  },
  {
    to: "about",
    label: "about",
  },
  {
    to: "how-it-works",
    label: "how_it_works2",
  },
  {
    to: "faqs",
    label: "FAQs",
  },
  {
    to: "contact",
    label: "Contact",
  },
];

export const footerNavs = [
  {
    to: "home",
    label: "Home",
    link: false,
  },
  {
    to: "about",
    label: "about",
    link: false,
  },
  {
    to: "how-it-works",
    label: "how_it_works",
    link: false,
  },
  {
    to: "faqs",
    label: "FAQs",
    link: false,
  },
];

export const socialIcon = [
  {
    img: <One />,
    link: "#!",
  },
  {
    img: <Facebook />,
    link: "#!",
  },
  {
    img: <Instagram />,
    link: "#!",
  },

  {
    img: <XSocial />,
    link: "#!",
  },
  {
    img: <Linkedin />,
    link: "#!",
  },
  {
    img: <Youtube />,
    link: "#!",
  },
];

export const faqData = [
  {
    id: 1,
    question: "faqs_question_one",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_one")}</SpanStyled>
    ),
  },
  {
    id: 2,
    question: "faqs_question_two",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_two")}</SpanStyled>
    ),
  },
  {
    id: 3,
    question: "faqs_question_three",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_three")}</SpanStyled>
    ),
  },
];
export const faqSecData = [
  {
    id: 1,
    question: "faqs_question_one",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_one")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="500">{t(`faqs_answer_one_bullet_${num}`)}</Span>
                  &nbsp;
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_one_below")}</SpanStyled>
      </>
    ),
  },
  {
    id: 2,
    question: "faqs_question_two",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_two")}</SpanStyled>
    ),
  },

  {
    id: 9,
    question: "faqs_question_nine",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_nine")}</SpanStyled>
    ),
  },

  {
    id: 5,
    question: "faqs_question_five",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_five")}</SpanStyled>
    ),
  },
  {
    id: 6,
    question: "faqs_question_six",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_six")}</SpanStyled>
    ),
  },

  {
    id: 7,
    question: "faqs_question_seven",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_seven")}</SpanStyled>
    ),
  },
  {
    id: 3,
    question: "faqs_question_three",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_three")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="500">{t(`faqs_answer_three_bullet_${num}`)}</Span>
                  &nbsp;
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_three_below")}</SpanStyled>
      </>
    ),
  },
  // {
  //   id: 20,
  //   question: "faqs_question_twenty",
  //   render: (t) => (
  //     <>
  //       <SpanStyled>{t("faqs_answer_twenty")}</SpanStyled>
  //       <Box>
  //         <ul className="prTcList">
  //           {["one", "two", "three", "four"].map((num) => (
  //             <li key={num}>
  //               <Box>
  //                 <Span weight="500">
  //                   {t(`faqs_answer_twenty_bullet_${num}`)}
  //                 </Span>
  //                 &nbsp;
  //                 {/* <SpanStyled>
  //                   {t(`faqs_answer_one_bullet_${num}_description`)}
  //                 </SpanStyled> */}
  //               </Box>
  //             </li>
  //           ))}
  //         </ul>
  //       </Box>
  //       <SpanStyled>{t("faqs_answer_twenty_below")}</SpanStyled>
  //     </>
  //   ),
  // },
  {
    id: 8,
    question: "faqs_question_eight",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_eight")}</SpanStyled>
    ),
  },
  {
    id: 4,
    question: "faqs_question_four",
    render: (t, language) => (
      <>
        <SpanStyled>{t("faqs_answer_four")}</SpanStyled>
        <Box className="mt-3">
          <SpanStyled>{t("faqs_answer_middle")}</SpanStyled>
        </Box>

        <Box>
          <ul>
            {["one", "two", "three"].map((num) => (
              <li style={{ listStyle: "none" }} key={num}>
                <Box>
                  <Span weight="500">
                    {t(`faqs_answer_four_bullet_${num}`)}
                  </Span>
                  {/* &nbsp; */}
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
  {
    id: 10,
    question: "faqs_question_ten",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_ten")}</SpanStyled>
    ),
  },
  {
    id: 11,
    question: "faqs_question_eleven",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_eleven")}</SpanStyled>
    ),
  },
  {
    id: 12,
    question: "faqs_question_twelve",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_twelve")}</SpanStyled>
    ),
  },
  {
    id: 13,
    question: "faqs_question_thirteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_thirteen")}</SpanStyled>
    ),
  },
  {
    id: 14,
    question: "faqs_question_fourteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_fourteen")}</SpanStyled>
    ),
  },
  {
    id: 15,
    question: "faqs_question_fifteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_fifteen")}</SpanStyled>
    ),
  },
  {
    id: 16,
    question: "faqs_question_sixteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_sixteen")}</SpanStyled>
    ),
  },
  {
    id: 17,
    question: "faqs_question_seventeen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_seventeen")}</SpanStyled>
    ),
  },
  {
    id: 18,
    question: "faqs_question_eighteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_eighteen")}</SpanStyled>
    ),
  },
  {
    id: 19,
    question: "faqs_question_nineteen",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_nineteen")}</SpanStyled>
    ),
  },
];
export const faqThirdData = [
  {
    id: 1,
    question: "faqs_question_one",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_one")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="500">{t(`faqs_answer_one_bullet_${num}`)}</Span>
                  &nbsp;
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_one_below")}</SpanStyled>
      </>
    ),
  },
  {
    id: 2,
    question: "faqs_question_two",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_two")}</SpanStyled>
    ),
  },

  {
    id: 9,
    question: "faqs_question_nine",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_nine")}</SpanStyled>
    ),
  },

  {
    id: 5,
    question: "faqs_question_five",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_five")}</SpanStyled>
    ),
  },
  {
    id: 6,
    question: "faqs_question_six",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_six")}</SpanStyled>
    ),
  },
  {
    id: 7,
    question: "faqs_question_seven",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_seven")}</SpanStyled>
    ),
  },

  {
    id: 3,
    question: "faqs_question_three",
    render: (t) => (
      <>
        <SpanStyled>{t("faqs_answer_three")}</SpanStyled>
        <Box>
          <ul className="prTcList">
            {["one", "two", "three", "four"].map((num) => (
              <li key={num}>
                <Box>
                  <Span weight="500">{t(`faqs_answer_three_bullet_${num}`)}</Span>
                  &nbsp;
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
        <SpanStyled>{t("faqs_answer_three_below")}</SpanStyled>
      </>
    ),
  },

  // {
  //   id: 20,
  //   question: "faqs_question_twenty",
  //   render: (t) => (
  //     <>
  //       <SpanStyled>{t("faqs_answer_twenty")}</SpanStyled>
  //       <Box>
  //         <ul className="prTcList">
  //           {["one", "two", "three", "four"].map((num) => (
  //             <li key={num}>
  //               <Box>
  //                 <Span weight="500">
  //                   {t(`faqs_answer_twenty_bullet_${num}`)}
  //                 </Span>
  //                 &nbsp;
  //                 {/* <SpanStyled>
  //                   {t(`faqs_answer_one_bullet_${num}_description`)}
  //                 </SpanStyled> */}
  //               </Box>
  //             </li>
  //           ))}
  //         </ul>
  //       </Box>
  //       <SpanStyled>{t("faqs_answer_twenty_below")}</SpanStyled>
  //     </>
  //   ),
  // },
  {
    id: 8,
    question: "faqs_question_eight",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_eight")}</SpanStyled>
    ),
  },
  {
    id: 4,
    question: "faqs_question_four",
    render: (t, language) => (
      <>
        <SpanStyled>{t("faqs_answer_four")}</SpanStyled>
        <Box className="mt-3">
          <SpanStyled>{t("faqs_answer_middle")}</SpanStyled>
        </Box>

        <Box>
          <ul>
            {["one", "two", "three"].map((num) => (
              <li style={{ listStyle: "none" }} key={num}>
                <Box>
                  <Span weight="500">
                    {t(`faqs_answer_four_bullet_${num}`)}
                  </Span>
                  {/* &nbsp; */}
                  {/* <SpanStyled>
                    {t(`faqs_answer_one_bullet_${num}_description`)}
                  </SpanStyled> */}
                </Box>
              </li>
            ))}
          </ul>
        </Box>
      </>
    ),
  },
  {
    id: 10,
    question: "faqs_question_ten",
    render: (t) => (
      <SpanStyled color="var(--text4)">{t("faqs_answer_ten")}</SpanStyled>
    ),
  },
];

export const whyFalSecData = [
  "feature_verified_professionals",
  "feature_localized_expertise",
  "feature_detailed_profiles",
  "feature_smart_search_filters",
  "feature_direct_contact_options",
  "feature_responsive_support",
  "feature_real_reviews",
  "feature_multilingual_agents",
  "feature_transparent_information",
  "feature_trusted_by_thousands",
];

export const howItWorksData = [
  {
    title: "steps_search_professionals_title",
    description: "steps_search_professionals_description",
    icon: SearchPro,
    numberIcon: ZeroOne,
  },
  {
    title: "steps_explore_results_title",
    description: "steps_explore_results_description",
    icon: ExploreMatching,
    numberIcon: Two,
  },
  {
    title: "steps_view_profiles_title",
    description: "steps_view_profiles_description",
    icon: ViewProfile,
    numberIcon: Three,
  },
  {
    title: "steps_send_inquiries_title",
    description: "steps_send_inquiries_description",
    icon: GetView,
    numberIcon: Four,
  },
];

export const whyFalData = [
  "all_in_one_digital_profile",
  "branded_and_customizable",
  "lead_generation",
  "smart_analytics",
  "seamless_sharing",
  "mobile_friendly_and_fast",
  "seo_and_visibility_boost",
  "integrated_media_and_links",
  "time_saving_and_efficient",
];

export const howItWorksSecData = [
  {
    title: "create_your_profile",
    description: "setup_real_estate_profile",
    icon: CreateProfile,
    numberIcon: ZeroOne,
  },
  {
    title: "add_your_listings_and_links",
    description: "showcase_properties",
    icon: AddListing,
    numberIcon: Two,
  },
  {
    title: "share_and_grow",
    description: "use_your_link",
    icon: ShareGrow,
    numberIcon: Three,
  },
  {
    title: "get_views_and_inquiries",
    description: "attract_buyers",
    icon: GetView,
    numberIcon: Four,
  },
];

export const roles = [
  { id: 1, role: "marketer" },
  { id: 2, role: "broker" },
  { id: 3, role: "both" },
];
export const listingTypes = [
  { id: 1, label: "for_rent" },
  { id: 2, label: "for_sale" },
];
export const statusTypes = [
  { id: 1, label: "ready" },
  { id: 2, label: "off_plan" },
];

export const falHubAboutContentKeys = [
  "fal_hub_intro",
  "property_seekers_description",
  "agent_profile_feature"
];